module.exports = __webpack_public_path__ + "img/item7.abf6be73.png";